import { prepareSite } from '../../site-switch/bootstrap';

void prepareSite('mobile')
  .then((shouldStart) => {
    if (shouldStart) {
      return import('./mobile-main');
    }
    return undefined;
  })
  .catch(() => import('./mobile-main'));
